<template>
	<div class="connected-ambassador" v-if="currentPage && currentPage.acf && currentPage.acf.ambassador">
        <div class="resultats" v-if="loadingPostsStatus === 'success' && postItems[0]">
            <WpLink :url="postItems[0].link" :title="postItems[0].title"  @mouseover.native="isHovered = true" @mouseout.native="isHovered = false" class="inner">
            <WpImage 
                v-if="postItems[0].featured_image" 
                :image="postItems[0].featured_image"
                size="medium_large"
                class="image"
                background 
                cover
            />
            <div class="content-area padding-lg">
                <h2 class="titler">Hvordan er det å jobbe som <br/>{{currentPage.title.toLowerCase()}}?</h2>
                <Button hasIcon iconType="link" :class="{'hover' : isHovered}" aria-label="Les hva Ola forteller" class="button-cta" type="darkLight">
                    <span v-html="'Les hva '+postItems[0].acf.first_name+' forteller'" />
                </Button>
            </div>
        </WpLink>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { arrow } from '@/components/../icons';
import Button from '@/components/elements/Button'
import WpLink from '@/components/elements/WpLink'
import WpImage from '@/components/elements/WpImage'

export default {
    name: 'connected-ambassador',
    data(){
        return {
            postItems: [],
            isHovered: false,
            loadingPostsStatus: 'loading',
        }
    },
    components:{
        Button,
        WpLink,
        WpImage
    },
    mounted(){
        const VM = this;

        if( !(VM.currentPage && VM.currentPage.acf && VM.currentPage.acf.ambassador) ) return false
        VM.loadingPostsStatus = 'loading'
        VM.getPost(VM.loadOpt).then(res=>{
            if(res.data && res.data.posts && res.data.posts.length){
                VM.loadingPostsStatus = 'success'
                VM.postItems = res.data.posts
            }else{
                VM.loadingPostsStatus = 'notFound'  
            }
        })
    },
    computed: {
        ...mapGetters([
            'currentPage',
            'isFrontPage'
        ]),
         arrowIcon(){
            return arrow('#00344D')
        },
        loadOpt(){
            const VM = this;
            const opt = {
                type: 'ambassadors',
                limit : this.currentPage.acf.ambassador.length,
                include : this.currentPage.acf.ambassador
            }

            return opt;
        }
    },
    methods:{
        ...mapActions([
			'getPost',
        ]),
        
    }
    
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.connected-ambassador{
    max-width: 1000px;
    .resultats{
        .inner{
            border-radius: $blocksRadius;
            display: block;
            cursor: pointer;
            background-color: #fff;
            transition: 0.2s background ease-in-out, 0.2s color ease-in-out;
            text-decoration: none;
            display: flex;
            overflow: hidden;
            @include mquery($phone){
                display: block;
            }
            .wp-image-vue{
                min-width: 40%;
                width: 40%;
                .image{
                    height: 100%;
                    padding-bottom: 0;
                }
                @include mquery($phone){
                    min-width: 100%;
                    width: 100%;
                    .image{
                        height: 0;
                        padding-bottom: 56.4%;
                    }
                }
            }
            .button-cta{
                display: flex;
                width: 100%;
                justify-content: space-between;
                margin-top: 30px;
                @include mquery($tablet){
                    margin-top: 20px;
                }
                @include mquery($phone){
                    margin-top: 10px;
                }
            }
            .titler{
                margin-bottom: 20px;
                margin-top: 0;
            	@include fluid-type($smallResText, $wideResText, 18px, 30px);
                @include mquery($phone){
                    margin-bottom: 15px;
                }
            }
            &:hover{
                background-color: $darkLight;
                color: #fff;
                
            }
        }
    }
}
</style>
